module.exports = __webpack_public_path__ + "static/media/gryphon-house-living-dining-light.412f17ee.jpg";